import type { ValueOptions } from "@mui/x-data-grid-pro";

/**
 * The due-date status vocab: the row `whiteboard_status` ("0:Closed,1:Open,2:Not Applicable"
 * on g2 / mustang / peak / demo), which useConfig("whiteboard") receives as `status`, a dict.
 * There is no `status_list` key; the grids gated on it and showed no status filter options
 * (config-gate audit A9). Legacy reads the same row (mod_whiteboard/includes/whiteboard_nav.inc:174).
 */
type WhiteboardConfig = { [key: string]: any } | undefined;

const vocab = (config: WhiteboardConfig): { [code: string]: string } | undefined =>
  config?.status && typeof config.status === "object" && !Array.isArray(config.status)
    ? config.status
    : undefined;

/** Filter options for a Status column: "Any", then the vocab by label. */
export function whiteboardStatusOptions(config: WhiteboardConfig): ValueOptions[] | undefined {
  const status = vocab(config);
  if (!status) return undefined;
  const options = Object.keys(status).map((code) => ({ value: code, label: status[code] }));
  options.sort((a, b) => a.label.localeCompare(b.label, "en", { sensitivity: "base" }));
  return [{ value: "", label: "Any" }, ...options];
}

/** A status code's label, upper-cased; the code itself when the vocab lacks it. */
export function whiteboardStatusLabel(config: WhiteboardConfig, code: unknown): string | undefined {
  if (code == null || code === "") return undefined;
  const label = vocab(config)?.[String(code)];
  return label ? label.toUpperCase() : String(code);
}
